<template>
  <p>select a piece of artwork to get started</p>
  <div class="gallery-container">
    <router-link to="/about" class="about-btn">About</router-link>
    <!-- Google Fonts are now loaded in public/index.html -->
    <div class="gallery-grid">
      <div v-for="(img, idx) in images" :key="idx" class="gallery-item" @click="onImageClick(img)">
        <img :src="img.src" :alt="img.alt" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaperBoat',
  data() {
    return {
      images: [
        { src: require('../assets/big-line-waves.jpg'), alt: 'Big Line Waves', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/woman-orange-book.jpg'), alt: 'Woman Orange Book', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' },
        { src: require('../assets/bird-beach-abstract.jpg'), alt: 'Bird Beach Abstract', etsyUrl: 'https://www.etsy.com/shop/ChaosandWonderDesign' },
        { src: require('../assets/orange-cat-green-chair.jpg'), alt: 'Orange Cat Green Chair', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' },
        { src: require('../assets/black-heart.jpg'), alt: 'Black Heart', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/body-line.jpg'), alt: 'Body Line', etsyUrl: 'https://www.etsy.com/shop/LZatelier' },
        { src: require('../assets/cat-behind-wall.jpg'), alt: 'Cat Behind Wall', etsyUrl: 'https://www.etsy.com/shop/ItemssyPrints' },
        { src: require('../assets/floral-profile-woman.jpg'), alt: 'Floral Profile Woman', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/orange-sun-green-ocean.jpg'), alt: 'Orange Sun Green Ocean', etsyUrl: 'https://www.etsy.com/shop/LidoDesignCo' },
        { src: require('../assets/orange-mandala.jpg'), alt: 'Orange Mandala', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/peach-mountains.jpg'), alt: 'Peach Mountains', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/poppies.jpg'), alt: 'Poppies', etsyUrl: 'https://www.etsy.com/shop/FirumWalls' },
        { src: require('../assets/reading-in-bathroom.jpg'), alt: 'Reading in Bathroom', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' },
        { src: require('../assets/resting-couch-hotchocolate.jpg'), alt: 'Resting Couch Hot Chocolate', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' },
        { src: require('../assets/sailboat.jpg'), alt: 'Sailboat', etsyUrl: 'https://www.etsy.com/shop/BleuMarieArtwork'},
        { src: require('../assets/settingsun-birds-ocean.jpg'), alt: 'Setting Sun Birds Ocean', etsyUrl: 'https://www.etsy.com/shop/BleuMarieArtwork' },
        { src: require('../assets/teal-wave-orange-flowers.jpg'), alt: 'Teal Wave Orange Flowers', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' },
        { src: require('../assets/woman-many-faces.jpg'), alt: 'Woman Many Faces', etsyUrl: 'https://www.etsy.com/shop/NoirPixelStudio' }
      ]
    }
  },
  methods: {
    onImageClick(img) {
      // Pass image and etsyUrl as query params
      this.$router.push({
        name: 'JournalPage',
        query: {
          image: img.src,
          etsy: img.etsyUrl
        }
      });
    }
  }
});
</script>

<style scoped>
 .gallery-container {
   width: 80vw;
   margin: 30px auto 0 auto;
 }
 .gallery-container h1 {
   font-family: 'Fredericka the Great', cursive, serif;
   font-size: 2.75rem;
   letter-spacing: 4px;
   margin-bottom: 10px;
   color: #444;
   font-weight: normal;
   opacity: 0.85;
   text-align: left;
 }
 .gallery-grid {
   display: grid;
   grid-template-columns: repeat(5, 1fr);
   gap: 30px;
   margin-top: 30px;
 }

@media (max-width: 600px) {
  .gallery-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-top: 10px;
  }
  .gallery-container {
    width: 80vw;
    margin: 0 auto 0 auto;
  }
  .about-btn {
    top: 12px;
    right: 10px;
    font-size: 1rem;
    padding: 0.4em 1em;
  }
  .gallery-container h3 {
    margin-bottom: 0px;
  }
}
 .gallery-item img {
   width: 100%;
   height: auto;
   object-fit: contain;
   display: block;
   background: #fff;
   cursor: pointer;
   transition: transform 0.2s, box-shadow 0.2s;
   border-radius: 0;
   box-shadow: 0 2px 8px rgba(0,0,0,0.08);
 }
 .gallery-item img:hover {
   transform: scale(1.05);
   box-shadow: 0 4px 16px rgba(0,0,0,0.15);
 }

.about-btn {
  position: absolute;
  top: 24px;
  right: 36px;
  z-index: 10;
  background: #ff9800;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.5em 1.3em;
  font-size: 1.1rem;
  font-family: 'Segoe UI', 'Roboto', sans-serif;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  text-decoration: none;
  transition: background 0.2s;
}
.about-btn:hover {
  background: #fb8c00;
}
</style>
